<template>
  <section class="menu-tabs">
    <el-tabs :value="active"  @tab-click="handleTabClick" @tab-remove="handleTabRemove">
      <el-tab-pane closable v-for="menu in menus " :key="menu.name" :name="menu.name">
        <span slot="label">
          <span class="menu-icon iconfont" :class="'icon'+menu.meta.icon"></span>
          {{menu.meta.zhname}}
        </span>
      </el-tab-pane>
    </el-tabs>
    <el-tooltip class="item" effect="dark" content="刷新页面" placement="top-start">
      <i class="el-icon-refresh-right" @click='handleFresh' style="margin-right:10px;font-size:18px;cursor: pointer"></i>
    </el-tooltip>
    <el-dropdown @command="handleClose">
      <span class="close-btn">一键关闭
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="1">关闭当前</el-dropdown-item>
        <el-dropdown-item :command="2">关闭其他</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: '',
  components: {},
  props: {
  },
  computed: {
    ...mapGetters({
      'menus': 'tabList',
      'active': 'tabActive'
    })
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
    handleTabClick (item) {
      const menuInfo = this.menus.find(menu => menu.name === item.name)
      this.$router.push(menuInfo)
    },
    handleFresh () {
      this.$store.dispatch('setFreshState')
    },
    handleClose (type) {
      switch (type) {
        case 1:
          this.handleTabRemove(this.$route.name)
          break
        case 2:
          this.menus.forEach(menu => {
            if (menu.name !== this.$route.name) {
              this.handleTabRemove(menu.name)
            }
          })
          break
        case 3:
          this.menus.forEach(menu => {
            this.handleTabRemove(menu.name)
          })
          break
        default:
          break
      }
    },
    handleTabRemove (item) {
      console.log(this)
      this.$store.dispatch('removeTab', item)
      // this.$destroy('AddCompany')
    }
  }
}
</script>
<style lang='less'>
.menu-tabs{
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  // padding:0 16px;
  padding-right:16px;
  padding-bottom: 0;
  .el-tabs{
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    margin-right: 20px;
    >.el-tabs__header{
      padding-top: 9px;
      margin-bottom: 0;
      .el-tabs__nav-prev{
         left: 3px
      }
      .el-tabs__nav-prev,.el-tabs__nav-next{
        line-height: 32px;
      }
      >.el-tabs__nav-wrap{
        padding: 0 16px;
        &::after{
          display: none
        }
        .el-tabs__nav-scroll{
          .el-tabs__nav{
            display: flex;
            .el-tabs__item{
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
              background-color: #37638c;
              padding: 8px 16px 10px 24px;
              margin-right: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              line-height: 22px;
              letter-spacing: 0;
              color: rgba(255, 255, 255, .8);
              .el-icon-close{
                width: 20px;
              }
              .el-icon-close:hover{
                color: #fff;
                background-color: #3F72A2;
                height: 20px;
                line-height: 20px;
                width: 20px;
              }
              &.is-active{
                background-color: #009dc2;
                color: #fff;
                .el-icon-close:hover{
                  color: #fff;
                  background-color: #0BAFD6;
                  height: 20px;
                  line-height: 20px;
                  width: 20px;
                }
              }
            }
            .el-tabs__active-bar{
              display: none;
            }
          }
        }
      }
    }
    >.el-tabs__content{
      flex: 1;
      >.el-tab-pane{
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
  .close-btn{
    min-width: 100px;
    padding-left: 10px;
    border-left: 1px solid #999;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/views/layout/MenuTabs.vue